import React from 'react';
import CartSummary from './Components/CartSummary';
import { TranslationContext, SettingsContext } from "./Components/Context";

function CartApp(props) {
    return (
        <SettingsContext.Provider value={
            {
                market: props.Market,
                language: props.Language,
                contextitemid: props.ContextItemId,
                datasourceitemid: props.DataSourceItemId,
                continueShoppingUrl: props.ContinueShoppingUrl,
                defaultThumbnailImageUrl: props.DefaultThumbnailImageUrl,
                zoomIconUrl: props.ZoomIconUrl
            }}>
            <TranslationContext.Provider value={props.Translations}>
                <CartSummary countries={props.Countries} />
            </TranslationContext.Provider>
        </SettingsContext.Provider>
    );
}

export default CartApp;
